import styled from "styled-components";

interface ITableHeader {
  gridTemplateColumns?: string;
}
export const TableHeader = styled.div<ITableHeader>`
  ${({ gridTemplateColumns, theme }) => `
    color: ${theme.colors.gray};
    font-family: ${theme.fontFamilies.primaryFont};
    grid-template-columns: ${gridTemplateColumns};
  `}
  box-sizing: border-box;
  display: grid;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  margin-top: 3rem;
  padding: 0 1.5rem;

  .center {
    text-align: center;
  }

  & > div {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .left-align {
    align-items: flex-start;
  }
`;

interface ITableBody {
  gridTemplateColumns?: string;
}
export const TableBody = styled.div<ITableBody>`
  margin-bottom: 3rem;

  & > div {
    grid-template-columns: ${(props) => props.gridTemplateColumns};
    margin-top: 0.8rem;
  }

  .clickable-element {
    cursor: pointer;
  }

  .edit-icon {
    background-color: ${(props) => props.theme.colors.primaryBlue};

    align-items: center;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
    display: flex;
    height: 3.8rem;
    justify-content: center;
    width: 3.8rem;

    & > img {
      height: 1.9rem;
      width: 1.9rem;
    }

    :hover {
      background-color: ${(props) => props.theme.colors.primaryBlue} !important;
      border-color: ${(props) => props.theme.colors.primaryBlue} !important;
    }
  }
`;
interface IRow {
  height?: string;
}
export const Row = styled.div<IRow>`
  ${({ theme, height }) => `
    background-color: ${theme.colors.white};
    min-height: ${height ? height : "7.2rem"};
  `}

  border-radius: 1rem;
  box-sizing: border-box;
  display: grid;
  font-size: 1.4rem;
  font-weight: 500;
  padding: 0 2.4rem;
  margin-bottom: 1rem;
  &.clickable {
    cursor: pointer;
  }

  & > div {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .left-align {
    align-items: flex-start;
    flex-direction: column;
  }

  .actions {
    display: flex;
    gap: 1rem;
  }
`;

export const FakeRow = styled.div`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background-size: 1400px 104px;
  background: #ffffff;
  background: linear-gradient(to right, #ffffff 8%, #f6f6f6 18%, #ffffff 33%);
  border-radius: 1rem;
  height: 6.3rem;
  margin: 0.5rem 0;
  position: relative;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -668px 0;
    }
    100% {
      background-position: 668px 0;
    }
  }
`;

export const AmountInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IContainer {
  gridTemplateColumns?: string;
}
export const Container = styled.div<IContainer>`
  .titles {
    display: none;
  }

  .item-container {
    grid-template-columns: ${(props) => props.gridTemplateColumns};
  }

  .attribute {
    margin: 0 !important;
  }

  @media (max-width: 600px) {
    .titles {
      ${(props) => `
        color: ${
          props.theme.colors.blackTextBody + props.theme.transparencies.p58
        };
        font-family: ${props.theme.fontFamilies.primaryFont};
      `}
      display: block;
      font-size: 1.2rem;
      font-weight: 700;
      justify-self: start;
      padding-left: 1rem;
      text-align: initial;
    }

    div {
      padding: 0.2rem 0;
    }

    & > div:first-of-type {
      display: none;
    }

    .item-container {
      grid-template-columns: 1fr;
      row-gap: 0.5rem;
    }

    .attribute {
      align-items: center !important;
      column-gap: 0.5 rem;
      display: grid;
      grid-template-columns: minmax(9em, 30%) 1fr;
      justify-items: center;

      & > :not(.titles) {
        text-align: center;
      }
    }
  }
`;
